@if (addressForm) {
  <div class="ld-session-block tw-flex tw-flex-col tw-font-body tw-gap-2"
    #form=""
    [formGroup]="addressForm"
    keyboardVisibility
    [keyboardVisibilityEnabled]="prefillAddressShiprocketExperiment">
    <!--  Name -->
    <div class="tw-relative">
      <div class="tw-flex tw-relative tw-overflow-hidden tw-mb-0">
        <input class="tw-h-12 tw-w-full tw-rounded-xl tw-bg-gray-100 tw-font-body tw-text-300 tw-text-black tw-pl-4 tw-pr-11 tw-border-0 placeholder:tw-opacity-100 placeholder:tw-tracking-normal" #nameInput [autocomplete]="true" formControlName="contactName" id="contactName" i18n-placeholder="@@yourName" placeholder="Your Name" [ngClass]='{ "redError": (isSaveForm && !addressForm?.get("contactName")?.valid) }' required="required" />
        @if (addressForm?.get('contactName')?.valid) {
          <ng-container *ngTemplateOutlet="checkIconTemplate"></ng-container>
        }
      </div>
      @if (addressFieldError.contactName.contactNameError) {
        <div class="tw-mb-1 tw-flex tw-items-center tw-pl-3 tw-gap-1.5">
          <img src="/assets/images/warn-err.png" class="tw-h-3" />
          @if (addressFieldError.contactName.errorType === 'nonEnglish') {
            <p i18n="@@errorNonEnglishName" class="tw-text-red-400 tw-text-200 tw-leading-none">Please enter name in English language only</p>
          }
          @if (addressFieldError.contactName.errorType === 'numbers') {
            <p i18n="@@errorNumbers" class="tw-text-red-400 tw-text-200 tw-leading-none">Please avoid using numbers</p>
          }
          @if (addressFieldError.contactName.errorType === 'specialCharacters') {
            <p i18n="@@errorSpecialCharacters" class="tw-text-red-400 tw-text-200 tw-leading-none">Please avoid using special characters and emojis</p>
          }
          @if (addressFieldError.contactName.errorType === 'wordLimit') {
            <p i18n="@@errorWordLimit" class="tw-text-red-400 tw-text-200 tw-leading-none">Only three words are allowed in name</p>
          }
          @if (addressFieldError.contactName.errorType === 'minCharLimit') {
            <p i18n="@@errorNameMinChar" class="tw-text-red-400 tw-text-200 tw-leading-none">Name must be at least 3 characters long</p>
          }
          @if (addressFieldError.contactName.errorType === 'maxCharLimit') {
            <p i18n="@@errorNameMaxChar" class="tw-text-red-400 tw-text-200 tw-leading-none">Name cannot exceed 25 characters</p>
          }
        </div>
      }
    </div>
    <!--  phone number-->
    <div>
      @if (isCheckout) {
        <div class="tw-flex tw-items-center tw-h-12 tw-w-full tw-rounded-xl tw-bg-gray-100 tw-overflow-hidden tw-px-[18px]">
          <span class="tw-font-body tw-text-300 tw-text-black">+91</span>
          <div class="tw-border tw-border-t-0 tw-border-r-0 tw-border-b-0 tw-border-black tw-h-8 tw-mx-1"></div>
          @if (!internalUser) {
            <input
              class="tw-w-full tw-h-full tw-font-body tw-text-300 tw-bg-transparent tw-border-0 placeholder:tw-opacity-100 placeholder:tw-tracking-normal tw-text-gray-400"
              required="required" #numberInput (keydown)="commonUtilService.acceptOnlyNumbers($event, 10)" (input)="sanitizeMobileInput('mobileNumber')" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="10" [autocomplete]="true" formControlName="mobileNumber" id="mobileNumber" i18n-placeholder="@@enterNumber" placeholder="Mobile Number" [ngClass]='{ "orangeError": (isSaveForm && !addressForm?.get("mobileNumber")?.valid) }'/>
          }
          @if (addressForm?.get('mobileNumber')?.valid) {
            <cs-icon class="tw-h-6 tw-w-6 tw-shrink-0 tw-ml-1 tw-text-teal-400" iconName="done"></cs-icon>
          }
        </div>
      }
      @if (isSaveForm && !addressForm?.get("mobileNumber")?.valid) {
        <div class="tw-text-red-400 tw-flex tw-items-center tw-pl-3 tw-mt-1">
          <img src="/assets/images/warn-err.png" class="tw-h-3" />
          <div class="tw-text-red-400 tw-text-200 tw-ml-1" i18n="@@enterValidMobileNumber">Enter a valid 10 digit mobile number.</div>
        </div>
      }
      @if (!showAlternateNo && !internalUser) {
        <div class="tw-text-200 tw-font-bold tw-text-teal-550 tw-mt-1" (click)="showAlternateNo = true">
          <span i18n="@@altNumber">
        + Add alternate phone no.
      </span>
        </div>
      }
    </div>
    <!--  alternate number-->
    @if (showAlternateNo) {
      <div>
        <div class="tw-flex tw-relative tw-mb-0">
          <input class="tw-h-12 tw-w-full tw-rounded-xl tw-bg-gray-100 tw-font-body tw-text-300 tw-text-black tw-pl-4 tw-pr-11 tw-border-0 placeholder:tw-opacity-100 placeholder:tw-tracking-normal" #alternateNumber="" id="alternateNumber" (keydown)="commonUtilService.acceptOnlyNumbers($event, 10)" (input)="sanitizeMobileInput('alternateNumber')" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="10" [autocomplete]="true" formControlName="alternateNumber" i18n-placeholder="@@enterAltNumber" placeholder="Alternate contact number" [ngClass]='{ "invalid": !alternateNumber.value?.length, "orangeError": (isSaveForm && !addressForm?.get("alternateNumber")?.valid) }' />
          @if (addressForm?.get('alternateNumber')?.value && addressForm?.get('alternateNumber')?.valid) {
            <div class="tw-absolute tw-right-4 tw-mt-2.5">
              <cs-icon class="tw-h-6 tw-w-6 tw-text-teal-400" iconName="done"></cs-icon>
            </div>
          }
        </div>
        @if (isSaveForm && !addressForm?.get("alternateNumber")?.valid) {
          <div class="tw-text-red-400 tw-flex tw-items-center tw-pl-3 tw-mt-1">
            <img src="/assets/images/warn-err.png" class="tw-h-3" />
            <div class="tw-text-red-400 tw-text-200 tw-ml-1" i18n="@@enterValidMobileNumber">Enter a valid 10 digit mobile number.</div>
          </div>
        }
      </div>
    }
    <!--  building-->
    <div class="tw-mb-0">
      <div class="tw-flex tw-relative tw-overflow-hidden tw-flex-col tw-gap-1">
        <input class="tw-h-12 tw-w-full tw-rounded-xl tw-bg-gray-100 tw-font-body tw-text-300 tw-text-black tw-pl-4 tw-pr-11 tw-border-0 placeholder:tw-opacity-100 placeholder:tw-tracking-normal" #buildingDetails required="required" formControlName="buildingDetails" id="buildingDetails" type="text" [placeholder]="buildingPlaceholder" [ngClass]='{ "orangeError": (isSaveForm && !addressForm?.get("buildingDetails")?.value) }' [autocomplete]="true" />
        @if (addressForm?.get('buildingDetails')?.value && !addressFieldError.buildingDetails.buildingDetailsError) {
          <ng-container *ngTemplateOutlet="checkIconTemplate"></ng-container>
        }
        @if (isSaveForm && !addressForm?.get("buildingDetails")?.value) {
          <div class="tw-text-red-400 tw-border-b-red-400 tw-flex tw-items-center tw-pl-3 mt-1">
            <img src="/assets/images/warn-err.png" class="tw-h-3" />
            <div class="tw-text-red-400 tw-text-200 tw-ml-1" i18n="@@errorHouse">
          Please enter House No. or Building No.
        </div>
          </div>
        }
      </div>
      @if (addressForm?.get('buildingDetails')?.value && addressFieldError.buildingDetails.buildingDetailsError) {
        <div class="tw-mt-1 tw-pl-3 tw-flex tw-items-center tw-gap-1.5">
          <img src="/assets/images/warn-err.png" class="tw-h-3" />
          @if (addressFieldError.buildingDetails.errorType === 'nonEnglish') {
            <p i18n="@@errorNonEnglishAddress" class="tw-text-red-400 tw-text-200 tw-leading-none">Please enter address in English language only</p>
          }
          @if (addressFieldError.buildingDetails.errorType === 'specialCharacters') {
            <p i18n="@@errorSpecialCharacters" class="tw-text-red-400 tw-text-200 tw-leading-none">Please avoid using special characters and emojis</p>
          }
          @if (addressFieldError.buildingDetails.errorType === 'minCharLimit') {
            <p i18n="@@errorBuildingDetailsMinChar" class="tw-text-red-400 tw-text-200 tw-leading-none">House No. must be at least 3 characters long</p>
          }
        </div>
      }
    </div>
    <!--  area-->
    <div class="tw-mb-0">
      <div class="tw-flex tw-relative tw-overflow-hidden tw-flex-col tw-gap-1">
        <input class="tw-h-12 tw-w-full tw-rounded-xl tw-bg-gray-100 tw-font-body tw-text-300 tw-text-black tw-pl-4 tw-pr-11 tw-border-0 placeholder:tw-opacity-100 placeholder:tw-tracking-normal" #localityDetails required="required" formControlName="localityDetails" id="localityDetails" type="text" [placeholder]="localityPlaceholder" [ngClass]='{ "orangeError": (isSaveForm && !addressForm?.get("localityDetails")?.value) }' [autocomplete]="true" />
        @if (isSaveForm && !addressForm?.get("localityDetails")?.value) {
          <div class="tw-text-red-400 tw-border-b-red-400 tw-flex tw-items-center tw-pl-3 mt-1">
            <img src="/assets/images/warn-err.png" class="tw-h-3" />
            <div class="tw-text-red-400 tw-text-200 tw-ml-1" i18n="@@errorArea">
                Please enter area or colony name
            </div>
          </div>
        }
        @if (addressForm?.get('localityDetails')?.value && !addressFieldError.localityDetails.localityDetailsError) {
          <ng-container *ngTemplateOutlet="checkIconTemplate"></ng-container>
        }
      </div>
      @if (addressForm?.get('localityDetails')?.value && addressFieldError.localityDetails.localityDetailsError) {
        <div class="tw-mt-1 tw-pl-3 tw-flex tw-items-center tw-gap-1.5">
          <img src="/assets/images/warn-err.png" class="tw-h-3" />
          @if (addressFieldError.localityDetails.errorType === 'nonEnglish') {
            <p i18n="@@errorNonEnglishAddress" class="tw-text-red-400 tw-text-200 tw-leading-none">Please enter address in English language only</p>
          }
          @if (addressFieldError.localityDetails.errorType === 'specialCharacters') {
            <p i18n="@@errorSpecialCharacters" class="tw-text-red-400 tw-text-200 tw-leading-none">Please avoid using special characters and emojis</p>
          }
          @if (addressFieldError.localityDetails.errorType === 'minCharLimit') {
            <p i18n="@@errorLocalityDetailsMinChar" class="tw-text-red-400 tw-text-200 tw-leading-none">Area name must be at least 5 characters long</p>
          }
        </div>
      }
    </div>
    <!--  Pincode-->
    <div class="tw-flex tw-flex-col tw-mb-0">
      <div class="tw-flex tw-justify-between tw-items-center tw-gap-[7px] tw-overflow-hidden">
        <div class="tw-flex tw-justify-between tw-items-center tw-h-12 tw-w-full tw-rounded-xl tw-bg-gray-100 tw-px-[18px]">
          <input class="tw-w-full tw-h-full tw-bg-transparent tw-font-body tw-text-300 tw-text-black tw-border-0 placeholder:tw-opacity-100 placeholder:tw-tracking-normal"
            #zipCodeInput required="required" type="number" pattern="[0-9]*" (keypress)="restrictSpecialChars($event)" (keydown)="commonUtilService.limitInputByMaxDigit($event, 6)" [autocomplete]="true" formControlName="zipCode" [placeholder]="pincodePlaceholder" id="zipCode" [ngClass]='{ "orangeError": (isSaveForm && (addressForm?.get("zipCode")?.value?.toString()?.length !== 6 || pinCodeError))}' />
          @if (addressForm?.get('zipCode')?.value?.toString()?.length === 6 && !pinCodeError) {
            <cs-icon class="tw-h-6 tw-w-6 tw-shrink-0 tw-ml-1 tw-text-teal-400" iconName="done"></cs-icon>
          }
        </div>
        <button [csButton]="fromReviewOrderPage() ? 'outlined' : ''"
          size="small"
          id="findMyPincode"
          type="button"
          class="tw-w-full tw-text-300 tw-font-semibold tw-align-middle tw-h-full tw-py-[5.5px] tw-rounded-2"
          [loading]="locationLoading"
          [spinnerSize]="20"
          [spinnerStrokeWidth]="2"
          (click)="getLocationDetails()"
          i18n="@@getPincode"
        >find my pincode</button>
      </div>
      @if (isSaveForm && (addressForm?.get("zipCode")?.value?.toString()?.length !== 6 || pinCodeError)) {
        <div class="tw-text-red-400 tw-border-b-red-400 tw-flex tw-items-center tw-pl-3 tw-mt-1">
          <img src="/assets/images/warn-err.png" class="tw-h-3" />
          <div class="tw-text-red-400 tw-text-200 tw-ml-1" i18n="@@errorPincode">
              Please enter a valid pincode
          </div>
        </div>
      }
    </div>
    <!--  city-->
    <div class="tw-mb-0">
      <div class="tw-flex tw-flex-col tw-gap-1">
        <div class="tw-flex tw-justify-between tw-items-center tw-h-12 tw-w-full tw-rounded-xl tw-bg-gray-100 tw-px-[18px]">
          <input class="tw-w-full tw-h-full tw-bg-transparent tw-font-body tw-text-300 tw-text-black tw-border-0 placeholder:tw-opacity-100 placeholder:tw-tracking-normal" #cityInput required="required" type="text" [autocomplete]="true" formControlName="city" id="city" [placeholder]="cityPlaceholder" [ngClass]='{ "orangeError": (isSaveForm && !addressForm?.get("city")?.value?.length) }' />
          <div class="tw-flex tw-items-center tw-shrink-0">
            <!-- if the length of state.value is > 10, just show the first word. for ex. Himachal pradesh should be Himachal-->
            @if (!pinCodeError && addressForm?.get('zipCode')?.value?.toString()?.length === 6 && addressForm?.get('city')?.value && addressForm?.get('state')?.value) {
              <div class="tw-text-100 tw-bg-gradient-to-b tw-from-white tw-to-gray-100 tw-ml-1">({{ addressForm?.get('state')?.value }})</div>
            }
            @if (addressForm?.get('city')?.value?.length && !addressFieldError.city.cityError) {
              <cs-icon class="tw-h-6 tw-w-6 tw-shrink-0 tw-ml-1 tw-text-teal-400" iconName="done"></cs-icon>
            }
          </div>
        </div>
        @if (isSaveForm && !addressForm?.get("city")?.value) {
          <div class="tw-text-red-400 tw-border-b-red-400 tw-flex tw-items-center tw-pl-3">
            <img src="/assets/images/warn-err.png" class="tw-h-3" />
            <div class="tw-text-red-400 tw-text-200 tw-ml-1" i18n="@@errorCity">
            Please enter City/Town/District
          </div>
          </div>
        }
      </div>
      @if (addressFieldError.city.cityError) {
        <div class="tw-mt-1 tw-pl-3 tw-flex tw-items-center tw-gap-1.5">
          <img src="/assets/images/warn-err.png" class="tw-h-3" />
          @if (addressFieldError.city.errorType === 'nonEnglish') {
            <p i18n="@@errorNonEnglishAddress" class="tw-text-red-400 tw-text-200 tw-leading-none">Please enter address in English language only</p>
          }
          @if (addressFieldError.city.errorType === 'specialCharacters') {
            <p i18n="@@errorSpecialCharacters" class="tw-text-red-400 tw-text-200 tw-leading-none">Please avoid using special characters and emojis</p>
          }
          @if (addressFieldError.city.errorType === 'wordLimit') {
            <p i18n="@@errorCityWordLimit" class="tw-text-red-400 tw-text-200 tw-leading-none">Only three words allowed for city name</p>
          }
        </div>
      }
    </div>
    <!--  landmark-->
    <div class="tw-mb-0">
      <div class="tw-flex tw-relative tw-overflow-hidden tw-flex-col tw-gap-1">
        <input class="tw-h-12 tw-w-full tw-rounded-xl tw-bg-gray-100 tw-font-body tw-text-300 tw-text-black tw-pl-4 tw-pr-11 tw-border-0 placeholder:tw-opacity-100 placeholder:tw-tracking-normal" #landmark="" type="text" [autocomplete]="true" [placeholder]="landmarkPlaceholder" formControlName="landmark" id="landmark" [ngClass]='{ "invalid": !landmark.value?.length }' />
        @if (addressForm?.get('landmark')?.value?.length && !addressFieldError.landmark.landmarkError) {
          <ng-container *ngTemplateOutlet="checkIconTemplate"></ng-container>
        }
      </div>
      @if (addressFieldError.landmark.landmarkError) {
        <div class="tw-mt-1 tw-pl-3 tw-gap-1.5 tw-flex tw-items-center">
          <img src="/assets/images/warn-err.png" class="tw-h-3" />
          @if (addressFieldError.landmark.errorType === 'nonEnglish') {
            <p i18n="@@errorNonEnglishAddress" class="tw-text-red-400 tw-text-200 tw-leading-none">Please enter address in English language only</p>
          }
          @if (addressFieldError.landmark.errorType === 'specialCharacters') {
            <p i18n="@@errorSpecialCharacters" class="tw-text-red-400 tw-text-200 tw-leading-none">Please avoid using special characters and emojis</p>
          }
        </div>
      }
    </div>
    <!--  radio button-->
    @if (!hideDefaultAddressSwitch) {
      <div class="tw-flex tw-items-center tw-h-12 tw-mb-0">
        <span class="tw-mr-5 tw-font-body tw-font-bold tw-text-300" i18n="@@makeAddressDefault">Set as default address</span>
        <input-switch [(checked)]="formDataFromParent.default" colorClass="tw-bg-teal-100"></input-switch>
      </div>
    }
    <!-- Slot for Shiprocket CTA when sticky is false (rendered inside address-form) -->
    <ng-content select="[shiprocketCta]"></ng-content>
  </div>
}

<ng-template #checkIconTemplate>
  <div class="tw-absolute tw-mt-2.5 tw-right-[18px]">
    <cs-icon class="tw-h-6 tw-w-6 tw-text-teal-400" iconName="done"></cs-icon>
  </div>
</ng-template>
